import { supabase, TABLES } from "../lib/supabase";
import type { Database } from "../pages/types/supabase";

type Role = Database["public"]["Tables"]["roles"]["Row"];

export async function getRoles(): Promise<Role[]> {
  const { data, error } = await supabase
    .from(TABLES.ROLES)
    .select("*")
    .order("role_name");

  if (error) throw error;
  return data || [];
}
